import { render, staticRenderFns } from "./PortalEdit.vue?vue&type=template&id=830aaf9a&scoped=true&"
import script from "./PortalEdit.vue?vue&type=script&lang=js&"
export * from "./PortalEdit.vue?vue&type=script&lang=js&"
import style0 from "./PortalEdit.vue?vue&type=style&index=0&id=830aaf9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830aaf9a",
  null
  
)

export default component.exports